

import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {
      loading: false,
      loading_f: false,
      tbv: null,
      tbv2: null,
      ventas: [],

      comercios_f: [],

      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
      }

    };
  },

  computed: {
    reporte: function () {
      return '/SERVER/scd/excel/?dsis='+window.sssdi+'&a=venLiDet' + '&desde=' + this.f_c.desde + '&hasta=' + this.f_c.hasta

    }
  },

  mounted: function () {
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,

      'rowCallback': function (row, data, index) {
        $(row).find('td:eq(12)').addClass('liqui-dat');
        $(row).find('td:eq(13)').addClass('liqui-dat');
        $(row).find('td:eq(14)').addClass('liqui-dat');
        $(row).find('td:eq(15)').addClass('liqui-dat');

      },



    });
    $('.box').boxWidget();

    //this.consultar();

  },

  methods: {
    consultar() {
      this.loading = true;

      this.tbv.clear();

      this.$http
        .post('/SERVER/scd/reportes/', {
          'a': 'venLiDet',
          'f': this.f_c
        }, {
          withCredentials: true
        })
        .then(response => {
          this.ventast_tabla = 0;
          if (response.data.status == 1) {

            for (let i = 0; i < response.data.data.length; i++) {

              response.data.data[i][9] = this.num_to_many(response.data.data[i][9]);
              response.data.data[i][12] = this.num_to_many(response.data.data[i][12]);
              response.data.data[i][13] = this.num_to_many(response.data.data[i][13]);
              response.data.data[i][14] = this.num_to_many(response.data.data[i][14]);
              response.data.data[i][15] = this.num_to_many(response.data.data[i][15]);

              this.tbv.row.add(response.data.data[i]);

            }

          }
          this.tbv.draw();

          this.loading = false;
        });

    },

  }


};



// WEBPACK FOOTER //
// ./src/components/reportes/ventasLiquiDet/tventas/tventas.js